export default __webpack_public_path__ + "static/media/cyborbusinessdarkmode.de4ebed5.svg";